// Auth guard: redireciona para /login se nao autenticado. Consumido
// dentro do `(app)/_layout.tsx` — toda rota protegida passa por la.
//
// Comportamento:
//   - isLoading: nao redireciona (boot ainda restaurando sessao).
//   - autenticado: nao redireciona; deixa shell renderizar.
//   - nao autenticado: navega para /login com state.from = pathname atual
//     (telas de login podem usar para retomar fluxo apos auth).
//
// Espelha mobile (`grana-money-app/src/shared/auth/use-protected-route.ts`),
// adaptado para react-router-dom (web). Mobile usa expo-router segments;
// web usa pathname.

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuthStore } from './auth.store';

export interface UseProtectedRouteResult {
  isLoading: boolean;
  isAuthenticated: boolean;
}

export function useProtectedRoute(): UseProtectedRouteResult {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate('/login', {
        replace: true,
        state: { from: `${location.pathname}${location.search}` },
      });
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname, location.search]);

  return { isLoading, isAuthenticated };
}
